import React from 'react';
import styled from '@emotion/styled';
const Heading = styled.h2 `
  color: #3f414d;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: normal;
  text-transform: uppercase;
  margin: 10px 10px 5px 10px;
`;
const WidgetTitle = ({ title }) => (React.createElement(Heading, null, title));
export default WidgetTitle;
